import React from "react";
import Marquee from "react-fast-marquee";
import { CaretUp, CaretDown } from "@phosphor-icons/react";

export default function CommodityTicker({ commodities }) {
  if (!commodities || commodities.length === 0) {
    return null;
  }

  return (
    <div className="bg-[#F0FDF4] border border-[#E0D4C8] rounded overflow-hidden">
      <Marquee speed={40} gradient={false} pauseOnHover>
          {commodities.map((commodity, index) => (
            <div
              key={commodity.symbol}
              data-testid={`ticker-${commodity.symbol.toLowerCase()}`}
              className="inline-flex items-center gap-4 px-8 py-2"
            >
              <span className="font-sans text-[11px] font-medium text-[#33302E]">
                {commodity.name}
              </span>
              <span className="font-sans text-[11px] text-[#33302E]">
                {commodity.display_price || `$${commodity.price.toFixed(2)}`}
              </span>
              {commodity.change_percent !== null && commodity.change_percent !== undefined && (
                <span
                  className={`inline-flex items-center gap-1 font-sans text-[11px] ${
                    commodity.change >= 0 ? "text-[#059669]" : "text-[#DC2626]"
                  }`}
                >
                  {commodity.change >= 0 ? (
                    <CaretUp size={14} weight="fill" />
                  ) : (
                    <CaretDown size={14} weight="fill" />
                  )}
                  {commodity.change >= 0 ? "+" : ""}
                  {commodity.change_percent.toFixed(2)}%
                </span>
              )}
              {index < commodities.length - 1 && (
                <span className="text-[#E5E7EB] ml-4">|</span>
              )}
            </div>
          ))}
        </Marquee>
    </div>
  );
}
